var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-coupon-config" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "200px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "员工每次发券组合能发X张",
                    prop: "staffPerIssueLimit",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, placeholder: "请输入数量" },
                    model: {
                      value: _vm.form.staffPerIssueLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "staffPerIssueLimit", $$v)
                      },
                      expression: "form.staffPerIssueLimit",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "员工多人发一次能发X用户",
                    prop: "staffMultiUserLimit",
                  },
                },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, placeholder: "请输入数量" },
                    model: {
                      value: _vm.form.staffMultiUserLimit,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "staffMultiUserLimit", $$v)
                      },
                      expression: "form.staffMultiUserLimit",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "同用户", prop: "userGlobalLimitDays" } },
                [
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: { min: 1, placeholder: "请输入天数" },
                        model: {
                          value: _vm.form.userGlobalLimitDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userGlobalLimitDays", $$v)
                          },
                          expression: "form.userGlobalLimitDays",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-text" }, [
                        _vm._v("天内,可领取"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: { min: 1, placeholder: "请输入次数" },
                        model: {
                          value: _vm.form.userGlobalLimitCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userGlobalLimitCount", $$v)
                          },
                          expression: "form.userGlobalLimitCount",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-text" }, [
                        _vm._v("次门店券"),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "同用户同门店", prop: "userStoreLimitDays" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: { min: 1, placeholder: "请输入天数" },
                        model: {
                          value: _vm.form.userStoreLimitDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userStoreLimitDays", $$v)
                          },
                          expression: "form.userStoreLimitDays",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-text" }, [
                        _vm._v("天内,可领取"),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        staticStyle: { width: "120px" },
                        attrs: { min: 1, placeholder: "请输入次数" },
                        model: {
                          value: _vm.form.userStoreLimitCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userStoreLimitCount", $$v)
                          },
                          expression: "form.userStoreLimitCount",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "form-text" }, [_vm._v("次")]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("保存配置")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }